import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { canAccessLocationSettings } from '&/features/settings/utils/settings-scope-access';

export const Route = createFileRoute('/_authenticated/settings_/locations/$locationId')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !canAccessLocationSettings(context.permissions)) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/locations/pages/location-detail-page')),
  staticData: { dynamic: true },
});
